import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import rrulePlugin from "@fullcalendar/rrule";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import moment from "moment";
import { db, updateUser } from "../../firebase/firebase.utils";
import { useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { BsClock, BsClockFill } from "react-icons/bs";

function PersonalCalendar({ miniCalendarRef }) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const spaceData = useSelector((state) => state.space.spaceData);
  const tasks = useSelector((state) => state.tasks.tasks);
  const navigate = useNavigate();
  //Calendar related
  const [otherProjects, setOtherProjects] = useState(false);

  const [activeCalShow, setActiveCalShow] = useState(false);

  const [activeCalStart, setActiveCalStart] = useState("00:00:00");
  const [activeCalEnd, setActiveCalEnd] = useState("24:00:00");

  const [slotDuration, setSlotDuration] = useState("00:15:00");
  const [slotLabelInterval, setSlotLabelInterval] = useState("01:00:00");

  const [searchParams, setSearchParams] = useSearchParams();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMode, setModalMode] = useState("");
  const [activeEvent, setActiveEvent] = useState({});
  const [events, setEvents] = useState([]);

  // const miniCalendarRef = useRef();

  var scrollTime = moment().format("HH") + ":00:00";

  const [trassignedTasks, setTrAssignedTasks] = useState([]);
  useEffect(() => {
    const assignedTasksTransformed = tasks?.map((astask) => {
      return {
        id: astask.id,
        title: astask.title,
        description: astask.description,
        done: astask.done,
        start: astask.startdate != null && astask.startdate.toDate(),
        end: astask.enddate != null && astask.enddate.toDate(),
        allDay: astask.allDay,
        duration: astask.duration,
        createdBy: astask.createdBy,
        createdAt: astask.createdAt,
        assign: astask.assign,
        phase: astask.phase,
        priority: astask.priority,
        progress: astask.progress,
        type: astask.type,
        rrule: astask.rrule,
        // color: "#909296",
        backgroundColor:
          astask.type === "habitReminder"
            ? "#1A82C4"
            : spaceData
                .filter((space) => space.spaceId === astask.fromSpaceId)
                .map((data) => data.color),
        borderColor: spaceData
          .filter((space) => space.spaceId === astask.fromSpaceId)
          .map((data) => data.color),
        // className: "this_project-items",
        fromSpaceId: astask.fromSpaceId,
        fromStationId: astask.fromStationId,
      };
    });
    setTrAssignedTasks([...assignedTasksTransformed]);
  }, [tasks]);

  const handleEventResize = (checkInfo) => {
    const id = checkInfo.event.id;
    if (
      checkInfo.event.extendedProps.fromSpaceId === `${currentUser.uid}-Inbox`
    ) {
      db.collection("users")
        .doc(currentUser.uid)
        .collection("tasks")
        .doc(id)
        .update({
          enddate: checkInfo.event.end,
        });
    } else {
      db.collection("space")
        .doc(checkInfo.event.extendedProps.fromSpaceId)
        .collection("stations")
        .doc(checkInfo.event.extendedProps.fromStationId)
        .collection("tasks")
        .doc(id)
        .update({
          enddate: checkInfo.event.end,
        });
    }
  };

  const handleEventDrop = (checkInfo) => {
    const id = checkInfo.event.id;
    if (
      checkInfo.event.extendedProps.fromSpaceId === `${currentUser.uid}-Inbox`
    ) {
      db.collection("users")
        .doc(currentUser.uid)
        .collection("tasks")
        .doc(id)
        .update({
          startdate: checkInfo.event.start,
          enddate: checkInfo.event.end,
        });
    } else {
      db.collection("space")
        .doc(checkInfo.event.extendedProps.fromSpaceId)
        .collection("stations")
        .doc(checkInfo.event.extendedProps.fromStationId)
        .collection("tasks")
        .doc(id)
        .update({
          startdate: checkInfo.event.start,
          enddate: checkInfo.event.end,
        });
    }
  };

  const handleEventReceive = (checkInfo) => {
    const id = checkInfo.event.id;
    if (
      checkInfo.event.extendedProps.fromSpaceId === `${currentUser.uid}-Inbox`
    ) {
      db.collection("users")
        .doc(currentUser.uid)
        .collection("tasks")
        .doc(id)
        .update({
          startdate: checkInfo.event.start,
          enddate: checkInfo.event.end,
        });
    } else {
      db.collection("space")
        .doc(checkInfo.event.extendedProps.fromSpaceId)
        .collection("stations")
        .doc(checkInfo.event.extendedProps.fromStationId)
        .collection("tasks")
        .doc(id)
        .update({
          startdate: checkInfo.event.start,
          enddate: checkInfo.event.end,
        });
    }
    checkInfo.revert();
  };

  const handleEventClick = (clickInfo) => {
    if (clickInfo.event.extendedProps.type === "habitReminder") {
      setSearchParams({ habit: clickInfo.event.extendedProps.fromStationId });
      // open the habit from the home screen
    } else {
      // const { id } = event.toPlainObject();
      handleOpenModal(
        "edit",
        {
          id: clickInfo.event.id,
          title: clickInfo.event.title,
          description: clickInfo.event.extendedProps.description,
          done: clickInfo.event.extendedProps.done,
          startdate: clickInfo.event.start,
          enddate: clickInfo.event.end,
          allDay: clickInfo.event.allDay,
          duration: clickInfo.event.extendedProps.durationn,
          createdBy: clickInfo.event.extendedProps.createdBy,
          createdAt: clickInfo.event.extendedProps.createdAt,
          assign: clickInfo.event.extendedProps.assign,
          phase: clickInfo.event.extendedProps.phase,
          priority: clickInfo.event.extendedProps.priority,
          progress: clickInfo.event.extendedProps.progress,
          type: clickInfo.event.extendedProps.type,
          fromSpaceId: clickInfo.event.extendedProps.fromSpaceId,
          fromStationId: clickInfo.event.extendedProps.fromStationId,
        },
        // events.find((e) => e.id.toString() === id.toString())
        // console.log(clickInfo)
      );
    }
  };

  const handleSelect = (selectionInfo) => {
    navigate("addtask", {
      state: {
        startdate: selectionInfo.start,
        startTime: selectionInfo.startDateTime,
        enddate: selectionInfo.end,
        endTime: selectionInfo.endDateTime,
      },
    });
    // handleOpenModal("add", {
    //   startdate: selectionInfo.start,
    //   startTime: selectionInfo.startDateTime,
    //   enddate: selectionInfo.end,
    // });
  };

  const MIN_SLOT_MINUTES = 15; // minimum zoom level (15 minutes)
  const MAX_SLOT_MINUTES = 60; // maximum zoom level (4 hours)
  const BASE_LABEL_MINUTES = 60; // ensure at least hourly labels

  const formatDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:00`;
  };

  const updateZoom = (newMinutes) => {
    // clamp zoom
    if (newMinutes < MIN_SLOT_MINUTES) newMinutes = MIN_SLOT_MINUTES;
    if (newMinutes > MAX_SLOT_MINUTES) newMinutes = MAX_SLOT_MINUTES;

    const newDuration = formatDuration(newMinutes);
    // label interval at least hourly or twice the slot, whichever is larger
    const labelMinutes = Math.max(BASE_LABEL_MINUTES, newMinutes * 2);
    const newLabel = formatDuration(labelMinutes);

    setSlotDuration(newDuration);
    setSlotLabelInterval(newLabel);

    const api = miniCalendarRef.current.getApi();
    api.setOption("slotDuration", newDuration);
    api.setOption("slotLabelInterval", newLabel);
    api.updateSize();
  };

  const zoomIn = () => {
    const [h, m] = slotDuration.split(":").map(Number);
    const totalMinutes = h * 60 + m;
    updateZoom(Math.floor(totalMinutes / 2));
  };

  const zoomOut = () => {
    const [h, m] = slotDuration.split(":").map(Number);
    const totalMinutes = h * 60 + m;
    updateZoom(totalMinutes * 2);
  };

  const handleOpenModal = (mode, event) => {
    // setModalMode(mode);
    // setActiveEvent(event);
    // setModalIsOpen(true);
    navigate(`task/${event.id}`);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setModalMode("");
    setActiveEvent({});
  };

  const changeWorkHours = () => {
    setActiveCalShow(!activeCalShow);
    if (activeCalShow) {
      setActiveCalStart("05:00:00");
      setActiveCalEnd("23:00:00");
    } else {
      setActiveCalStart("00:00:00");
      setActiveCalEnd("24:00:00");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div className="widgetheader" style={{justifyContent: "space-between", width: "100%"}}>
        <div>
          <h3>Calendar</h3>
        </div>
        <div>
          <button style={{ overflow: "visible" }} onClick={changeWorkHours}>
            {activeCalStart === "05:00:00" ? (
              <div
                style={{ display: "flex", alignItems: "center", columnGap: 5 }}
              >
                <BsClockFill />
                18h
              </div>
            ) : (
              <div
                style={{ display: "flex", alignItems: "center", columnGap: 5 }}
              >
                <BsClock />
                24h
              </div>
            )}
          </button>
        </div>
      </div>
      <div className="minical" id="minical" style={{ width: "100%" }}>
        <FullCalendar
          ref={miniCalendarRef}
          initialView="timeGridDay"
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            rrulePlugin,
            momentTimezonePlugin,
          ]}
          headerToolbar={{
            left: "prev,today,next,zoomOutButton,zoomInButton",
            center: "title",
            right:
              "WorkHoursButton timeGridDay,timeGridThreeDay,timeGridWeek,dayGridMonth",
          }}
          views={{
            timeGridThreeDay: {
              type: "timeGrid",
              duration: { days: 3 },
              buttonText: "3d",
              dayHeaderFormat: { weekday: "short" },
              dateIncrement: { days: 1 },
              titleFormat: { month: "short", day: "numeric" },
            },
            day: {
              dayHeaderFormat: { weekday: "long" },
              titleFormat: { month: "short", day: "numeric" },
            },
            dayGrid: {
              dayMaxEventRows: 4,
            },
          }}
          dayHeaderFormat={{ weekday: "short" }}
          customButtons={{
            class: "workhours__btn",
            // WorkHoursButton: {
            //   text: activeCalShow ? "24h" : "18h",
            //   click: function () {
            //     setActiveCalShow(!activeCalShow);
            //     if (activeCalShow) {
            //       setActiveCalStart("05:00:00");
            //       setActiveCalEnd("23:00:00");
            //     } else {
            //       setActiveCalStart("00:00:00");
            //       setActiveCalEnd("24:00:00");
            //     }
            //   },
            // },
            // class: "ProjectsButton",
            // ProjectsButton: {
            //   text: "Show All Projects",
            //   click: function () {
            //     setOtherProjects(!otherProjects);
            //   },
            // },
            // class: "BackNavButton",
            // BackButton: {
            //   text: "Back1day",
            //   click: function () {
            //     const duration = day;
            //     calendar.incrementDate( duration );
            //   },
            // },
            zoomInButton: { text: "+🔎", click: zoomIn },
            zoomOutButton: { text: "🔍-", click: zoomOut },
          }}
          eventClassNames={function (arg) {
            if (arg.event.extendedProps.done) {
              return ["cal__event-done"];
            }
            // else {
            //   return [ 'normal' ]
            // }
          }}
          height="100%"
          // height="100%"
          events={trassignedTasks}
          eventClick={handleEventClick}
          handleWindowResize={true}
          windowResizeDelay={10}
          select={handleSelect}
          editable={true}
          duration={"00:15"} // 2 hours
          selectable={true}
          displayEventEnd
          dayMaxEventRows
          moreLinkClick="day"
          nowIndicator="true"
          updateSize={true}
          slotDuration={slotDuration}
          slotLabelInterval={slotLabelInterval}
          eventResize={handleEventResize}
          eventDrop={handleEventDrop}
          eventReceive={handleEventReceive}
          slotMinTime={activeCalStart}
          slotMaxTime={activeCalEnd}
          scrollTime={scrollTime}
        />
      </div>
    </div>
  );
}

export default PersonalCalendar;
